import { io } from "socket.io-client"

// Returns at once: socket.io connects and reconnects by itself, and joinRoom joins on every connect.
// Waiting for the first connect here hung the app when that connect failed (DKT-58).
export function createWebSocketConnection(url: string) {
  return io(url)
}
